import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../../styles/BackToListButton.css';

type BackToListButtonProps = {
  label: string;
  to: string;
  ref?: React.Ref<HTMLDivElement>;
};

const BackToListButton: React.FC<BackToListButtonProps> = ({
  label,
  to,
  ref,
}) => {
  const navigate = useNavigate();

  return (
    <div className="position-fixed back-to-list-button-wrapper" ref={ref}>
      <Button
        type="button"
        className="back-to-list-button rounded-pill mt-5"
        aria-label={label}
        onClick={() => navigate(to)}
      >
        {label}
      </Button>
    </div>
  );
};

export default BackToListButton;
